import { Component, OnInit, ViewChild } from '@angular/core';

import { MessagePanelComponent }        from 'src/app/ui/components/shared/message-panel/message-panel.component';
import { ServerErrorManager }           from 'src/app/ui/components/utils/server-error-manager.utils';

import { ChunkGeneric }                 from 'src/app/domain/views/chunk-generic.view';

import { GenericException }             from 'src/app/domain/exceptions/generic.exception';
import { BookingBilling }               from 'src/app/business/models/billing/booking-billing.model';

import { ProviderBillingInteractor } from 'src/app/domain/interactor/provider/billing.interactor';

import { FindBillingFilterView } from 'src/app/domain/views/billing/find-invoices-filter.view';


@Component({
     selector: 'app-list-billing-provider',
     templateUrl: './list.component.html'
})
export class ProviderListBillingComponent implements OnInit {

     @ViewChild(MessagePanelComponent)
     private messagePanelComponent: MessagePanelComponent;

     chunkBookingBilling: ChunkGeneric<BookingBilling>;

     constructor(
          private providerBillingInteractor: ProviderBillingInteractor,
          private serverErrorManager: ServerErrorManager) {

     }


     ngOnInit() {
     }


     onFindBillingTrigger(findBillingFilterView: FindBillingFilterView) {

          if (this.messagePanelComponent) {
            this.messagePanelComponent.showLoading();
          }

          this.providerBillingInteractor.findBilling(findBillingFilterView.dateInit, findBillingFilterView.dateEnd, findBillingFilterView.keywords, findBillingFilterView.pageNumber)
          .subscribe(
               (chunkBookingBilling: ChunkGeneric<BookingBilling>) => {

                    this.chunkBookingBilling = chunkBookingBilling;
                    MessagePanelComponent.hideLoading();

               },
               (error: GenericException) => {

                    MessagePanelComponent.hideLoading();
                    this.serverErrorManager.manageErrorCode(error, this.messagePanelComponent);
               }
          )
     }

}
